<template>
  <div>
    <div class="d-flex align-center mb-4 h-35px px-1">
      <b-button-group class="ml-auto" size="sm">
        <button @click="addRule" class="btn btn-outline-info">
          <b-icon-diamond /> Add Time Blocks
        </button>
      </b-button-group>
    </div>
    <template v-for="(item, index) in currentQuery">
      <Action
        :rule="item"
        :options="options"
        :operators="operators"
        :key="index"
        class="mt-4 px-1"
        ref="action"
      />
      <!--      :selectedStatusId="selectedStatusId"-->
    </template>
  </div>
</template>

<script>
import Action from "@/own/components/warehouseManagement/warehouseSlotConfig/timeBlockBuilder/Action.vue";
export default {
  name: "ActionGroup",
  components: { Action },
  props: {
    currentQuery: {
      type: Array,
      required: true,
    },
    options: {
      type: Array,
    },
    operators: {
      type: Array,
      required: true,
    },
  },
  // data: function () {
  //   return { selectedStatusId: null };
  // },
  mounted: function () {
    this.$nextTick(() => {
      if (this.currentQuery.length === 0) {
        this.addRule();
      }
    });
  },
  // computed: {
  //   selectedStatusId: function () {
  //     // Status ID is 6
  //     return this.currentQuery.find((option) => option.id === 6)?.value;
  //   },
  // },
  methods: {
    addRule() {
      const newGroup = {
        // startHour: this.options[0].index + this.operators[0].index,
        // end: this.options[1].index + this.operators[0].index,
        startHour: this.options[0].text,
        startMinute: this.operators[0].text,
        endHour: this.options[1].text,
        endMinute: this.operators[0].text,
        // id: this.options[0].text,
        // value: null,
      };
      this.currentQuery.push(newGroup);
      this.$nextTick(() => {
        this.$refs.action.forEach((comp) => {
          comp.$v.$touch();
        });
      });
    },
  },
  // watch: {
  //   currentQuery: {
  //     handler() {
  //       // Status ID is 6 return_status
  //       this.selectedStatusId = this.currentQuery.find(
  //         (option) => option.id === 6 || option.id === 13
  //       )?.value;
  //     },
  //     deep: true,
  //   },
  // },
};
</script>
